



<nz-layout class="content-main page-wrapper max-width-1200">
  <nz-content>

    @if (showMenu) {
      <btlib-user-menu></btlib-user-menu>
    }
    <!-- [rolesRequired]="['SuperUser', 'Admin', 'Provider']"  -->

    @if (loginCheck) {
      <btlib-login-check ></btlib-login-check>
    }

    @if (bas.appLogin.success) {
      <div class="">
        <bt-page-wrapper>
          <ng-content></ng-content>
        </bt-page-wrapper>
      </div>
    }




  </nz-content>

</nz-layout>





